exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n/* Override Bootstrap buttons */\n\n.social-link {\n  padding: 10px 10px 0 10px;\n}\n\n.social-link[disabled] {\n  opacity: 0.3;\n  pointer-events: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/social.scss
// module id = 590
// module chunks = 0